const gsv = window.LOCAL_CONFIG.UC_GSV

/**
 * 获取RSA公钥
 */
export function getPublicKey (option) {
  return fetch.post(gsv + '/ws/common/get_publicKey', option)
}

export function getExtPublicKey (option) {
  return fetch.post(gsv + '/ws/common/get_ext_publicKey', option)
}

/**
 * 获取会员数据库配置项
 */
export function getSysConfig (option) {
  return fetch.post(gsv + '/ws/common/get_sysconfig', option)
}

export function getExtSysConfig (option) {
  return fetch.post(gsv + '/ws/common/get_ext_sysconfig', option)
}

/**
 * 获取会员前端库配置项
 */
export function getWebConfig (option) {
  return fetch.post(gsv + '/ws/common/get_webconfig', option)
}

export function getExtWebConfig (option) {
  return fetch.post(gsv + '/ws/common/get_ext_webconfig', option)
}

/**
 * 查询属性信息
 *
 * @returns {*}
 */
export function getAttrList (option) {
  return window.fetch.post(gsv + '/ws/form/get_attr_list', option)
}


/**
 * 获取用户头像
 * @returns {*}
 */
 export function getHeadImg (option) {
  return window.fetch.post(gsv + '/ws/get/head_img', option)
}